import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { PermissionService } from '../service/permission.service';

@Directive({
  selector: '[appHasPermission]',
})
export class TvaPermissionDirective {
  private templateRef = inject<TemplateRef<HTMLTemplateElement>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private permissionService = inject(PermissionService);

  @Input() set appHasPermission(permission: string[]) {
    this.isGranted(permission[0] as string, permission[1] as string, permission[2] as string);
  }

  private async isGranted(resourse: string, right: string, createdBy: string | null = null) {
    if (await this.permissionService.hasPermission(resourse, right, createdBy)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
